import React, { Component } from "react";
import { connect } from "react-redux";
import actions from "@/redux/action";
import { request } from "@/api/request";
import { message } from "antd";
import sentGAEvent from "@/ga";
import { withTranslation } from "react-i18next";

import AddLipShapeWorkFunction from "./addLipShapeFunction/AddLipShapeFunction";
import AddLipShapeWorkEmailFunction from "./addLipShapeWorkEmailFunction/AddLipShapeWorkEmailFunction";

import "@/assets/addLipShape.less";

class AddLipShapeWork extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      hasEmail: false,
      waitingTime: 0,
      template: null,
      isNotVerify: false,
    };
  }
  componentDidMount(){
    sentGAEvent({
      category: 'EnterFuncPage',
      action: '23FA_EnterFuncPage',
      label: 'Null',
    });
  }
  handleChooseTemplate = template => {
    sentGAEvent({
      category: "FaceAnimator",
      action: "FaceDemo",
      label: template,
    });
    this.setState({ template });
    if (this.state.hasEmail) {
      this.handleSubmit(template, () => this.setState({ step: 1 }));
    } else {
      this.setState({ step: 1 });
    }
  };

  uploadHasEmailCallback = (email, waitingTime) => {
    this.setState({ hasEmail: true, email, waitingTime, isNotVerify: true });
  };

  handleSubmit = async (template, callback) => {
    const url = this.props.currFile.videofileurl;
    let response = await this.requstAddLipShape(template, url);
    if (response.code === 200) {
      if (callback) {
        sentGAEvent({
          category: "ProcessStart",
          action: "23FA_ProcessStart",
        });
        callback();
      }
    } else {
      if (response.code === 402102) {
        this.props.onPurchaseModalObjChange({
          visible: true,
          type: "videoEditorTimesMoreThanLimit",
          trigger:'6TrialOver'
        });
        sentGAEvent({
          category: "UpgradePrompShow",
          action: "23FA_UpgradePrompShow",
        });
        this.setState({
          step: 0,
        });
      } else {
        message.warn("You have pending Dynamic Photo or Face Animator tasks, please retry after these tasks complete");
      }
    }
    console.log(response);
  };

  handleSubmitEmail = async (form, callback) => {
    this.setState({ email: form.email });
    let response = await this.requstEmail(form.email, form.firstName, form.lastName);
    if (response.code === 200) {
      if (callback) {
        callback();
      }
    } else {
      message.error(this.props.t("Too many attempts, please try again later."));
    }
  };

  handleSubmitVerifyCode = async (email, code, succCallback, errCallback) => {
    let response = await this.requstVerifyCode(email, code);
    if (response.code === 200) {
      sentGAEvent({
        category: "FaceAnimator",
        action: "FaceSuccess",
      });
      sentGAEvent({
        category: "ProcessStart",
        action: "23FA_ProcessStart",
      });
      if (succCallback) {
        succCallback();
        console.log(this.state.template);
        this.handleSubmit(this.state.template);
      }
    } else {
      if (errCallback) {
        errCallback();
      }
    }
  };

  requstAddLipShape = (template, url) => {
    const formData = new FormData();
    formData.append("template", template);
    formData.append("photo_url", url);
    formData.append("token", this.props.tokenId);
    return new Promise((resolve, reject) => {
      request(`faceAnimator`, {
        method: "post",
        body: formData,
      })
        .then(response => {
          
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  };

  getLanguageFormData = () => {
    const language = window.Storage.get("page-lang");
    let lang = "en";
    if (language) {
      switch (language) {
        case "inn":
          lang = "ih";
          break;
        default:
          lang = language;
          break;
      }
    }
    return lang;
  };

  requstEmail = (email, first_name, last_name) => {
    const formData = new FormData();
    formData.append("email", email);
    if (first_name) {
      formData.append("first_name", first_name);
    }
    if (last_name) {
      formData.append("last_name", last_name);
    }
    formData.append("token", this.props.tokenId);
    formData.append("language", this.getLanguageFormData());
    return new Promise((resolve, reject) => {
      request(`sendVerificationCode`, {
        method: "post",
        body: formData,
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  };

  requstVerifyCode = (email, verification_code) => {
    const formData = new FormData();
    verification_code = verification_code.replace(/\s+/g, "");
    formData.append("email", email);
    formData.append("verification_code", verification_code);
    formData.append("token", this.props.tokenId);
    return new Promise((resolve, reject) => {
      request(`verifyEmail`, {
        method: "post",
        body: formData,
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  };
  handleGoBack = () => {
    this.setState({ step: 0 })
    sentGAEvent({
      category: 'EnterFuncPage',
      action: '23FA_EnterFuncPage',
      label: 'Null',
    });
  };

  render() {
    return (
      <div className="workplace">
        {this.state.step === 0 ? (
          <AddLipShapeWorkFunction
            currFile={this.props.currFile}
            handleChooseTemplate={this.handleChooseTemplate}
            uploadHasEmailCallback={this.uploadHasEmailCallback}
            handleCloseCurrFile={() => this.props.onCurrFileChange(null)}
          />
        ) : this.state.step === 1 ? (
          <AddLipShapeWorkEmailFunction
            isNotVerify={this.state.isNotVerify}
            email={this.state.email}
            hasEmail={this.state.hasEmail}
            handleSubmitEmail={this.handleSubmitEmail}
            handleSubmitVerifyCode={this.handleSubmitVerifyCode}
            handleGoBack={this.handleGoBack}
          />
        ) : null}
      </div>
    );
  }
}



const mapStateToPropos = state => ({
  currFile: state.files.currFile,
  tokenId: state.common.tokenId,
});

const mapDispatchToProps = dispatch => ({
  onCurrFileChange: currFile => dispatch(actions.onCurrFileChange(currFile)),
  onPurchaseModalObjChange: purchaseModal => dispatch(actions.onPurchaseModalObjChange(purchaseModal)),
});

export default connect(mapStateToPropos, mapDispatchToProps)(withTranslation(["addLipShape"])(AddLipShapeWork));
